import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=0fe2c670"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=0fe2c670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WrapComponents: require('/app/nuxt/components/WrapComponents.vue').default,Swiper: require('/app/nuxt/components/Swiper.vue').default,DetailOverview: require('/app/nuxt/components/DetailPage/DetailOverview.vue').default,Section: require('/app/nuxt/components/Section.vue').default,DetailVideoSection: require('/app/nuxt/components/DetailPage/DetailVideoSection.vue').default,DetailAwardSection: require('/app/nuxt/components/DetailPage/DetailAwardSection.vue').default,DetailCard: require('/app/nuxt/components/DetailPage/DetailCard.vue').default})
